export default __webpack_public_path__ + "static/media/portfolio-hover-196.3af6a4d8.jpg";